import { useEffect } from 'react';

function DisableScrollRestoration() {
  useEffect(() => {
    // Disable the browser's automatic scroll restoration.
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return null;
}

export default DisableScrollRestoration; 